import { Component, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";

@Component({
    selector: 'admin-club-world-cup-playoff',
    templateUrl: 'club-world-cup-playoff.page.html',
    styleUrls: ['club-world-cup-playoff.page.scss'],
})
export class AdminDrawingClubWorldCupPlayoff implements OnInit {

    currentTab: number = 0;


    stages: any[] = [];

    const;

    constructor() { 
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
    }

    changeTab(tab: number) {
        this.currentTab = tab;
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages.push({key: CONSTANTS.euroCupStages.playoff8, name: CONSTANTS.euroCupStagesNames.playoff8});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff4, name: CONSTANTS.euroCupStagesNames.playoff4});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff2, name: CONSTANTS.euroCupStagesNames.playoff2});
        this.stages.push({key: CONSTANTS.euroCupStages.final, name: CONSTANTS.euroCupStagesNames.final});
    }
}